module.exports = __webpack_public_path__ + "static/media/logo.fa34b572.png";